import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
// import Sale from "views/admin/sale";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import ManageLicense from "views/admin/manageLicense";
import Requests from "views/admin/requests";
import News from "views/admin/news"
import Events from "views/admin/events"
import Management from "views/admin/management";
import Payment from "views/admin/payment";


// Icon Imports
import {
    MdHome,
    MdOutlineShoppingBag,
    MdBarChart,
    MdPerson,
    MdEventNote,
    MdNoteAdd,
    MdManageAccounts,
    MdOutlinePayments, MdComment, MdCategory,
} from "react-icons/md";
import CommentsIndexPage from "./views/admin/comments";
import CategoriesIndexPage from "./views/admin/categories";

const routes = [
    {
        name: "داشبرد",
        layout: "/admin",
        path: "default",
        icon: <MdHome className="h-6 w-6"/>,
        component: <MainDashboard/>,
    },
    {
        name: "اخبار",
        layout: "/admin",
        path: "news",
        icon: <MdOutlineShoppingBag className="h-6 w-6"/>,
        component: <Requests/>,
    },
    {
        name: "نظرات",
        layout: "/admin",
        path: "comments",
        icon: <MdComment className="h-6 w-6"/>,
        component: <CommentsIndexPage/>,
    },
    {
        name: "طبقه‌بندی‌ها",
        layout: "/admin",
        path: "categories",
        icon: <MdCategory className="h-6 w-6"/>,
        component: <CategoriesIndexPage/>,
    },
    // {
    //     name: "مدیریت",
    //     layout: "/admin",
    //     path: "management",
    //     icon: <MdManageAccounts className="h-6 w-6"/>,
    //     component: <Management/>,
    // },
    // {
    //   name: "Data Tables",
    //   layout: "/admin",
    //   icon: <MdBarChart className="h-6 w-6" />,
    //   path: "data-tables",
    //   component: <DataTables />,
    // },
    // {
    //   name: "Profile",
    //   layout: "/admin",
    //   path: "profile",
    //   icon: <MdPerson className="h-6 w-6" />,
    //   component: <Profile />,
    // },
];
export default routes;
